import { Button } from '@latitude/button';
import { Drawer } from '@latitude/drawer';
import { Text } from '@latitude/text';
import type { LANDING_PAGE_DRAWERS } from 'components/LandingPage/helpers';
import { getLandingPageDrawerContent } from 'components/LandingPage/helpers';
import { useFormType } from 'hooks/useFormType/useFormType';

export type DrawerID = LANDING_PAGE_DRAWERS;

type Props = {
  isOpen: boolean;
  onClose: () => void;
  drawerID: DrawerID;
};

const getDrawerContent = (
  id: DrawerID,
  isA1Application: boolean,
  isAdsdApplication: boolean,
  isArmadaApplication: boolean,
) => {
  const landingPageContent = getLandingPageDrawerContent(
    id,
    isA1Application,
    isAdsdApplication,
    isArmadaApplication,
  );
  return {
    title: landingPageContent?.title,
    content: landingPageContent?.content,
  };
};

const InfoDrawer = ({ drawerID, isOpen, onClose }: Props) => {
  const { isA1Application, isAdsdApplication, isArmadaApplication } =
    useFormType();
  const { title, content } = drawerID
    ? getDrawerContent(
        drawerID,
        isA1Application,
        isAdsdApplication,
        isArmadaApplication,
      )
    : { title: '', content: null };

  return (
    <Drawer
      onOpenChange={onClose}
      open={isOpen}
      contentStyles={{ padding: 0 }}
      footer={
        <Button className="ml-auto w-fit" onClick={onClose}>
          Close
        </Button>
      }
      title={<Text variant="headingSmall">{title}</Text>}
    >
      <div className="flex h-full flex-col gap-4 overflow-scroll">
        {content}
      </div>
    </Drawer>
  );
};

export default InfoDrawer;
